import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from 'react-oidc-context'
import { LoadingOverlay } from '@/components/ui'

export function CallbackPage() {
  const auth = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    // Once authentication is complete, redirect to home
    if (!auth.isLoading) {
      if (auth.isAuthenticated) {
        navigate('/', { replace: true })
      } else if (auth.error) {
        navigate('/login', { replace: true })
      }
    }
  }, [auth.isLoading, auth.isAuthenticated, auth.error, navigate])

  return <LoadingOverlay message="Completing sign in..." />
}
